module.exports = __webpack_public_path__ + "img/emsps-light.3762d636.webp";